import { WindowHelper } from '../WindowHelper';

export default class ProjectDetailMore {
    toggleVisibility() {
        document.querySelector('.is-main-text').classList.toggle('is-cropped');
        document.querySelector('.fade-overlay').classList.toggle('is-hidden');
        document.querySelector('a[data-type-trigger="more"]').classList.toggle('is-hidden');
        document.querySelector('a[data-type-trigger="less"]').classList.toggle('is-hidden');
    }

    attachEvent() {
        const triggerMore = document.querySelector('a[data-type-trigger]');
        const triggerLess = document.querySelector('a[data-type-trigger="less"]');

        if (triggerMore !== null) {
            triggerMore.addEventListener('click', this.toggleVisibility.bind(this), true);
        }

        if (triggerLess !== null) {
            triggerLess.addEventListener('click', this.toggleVisibility.bind(this), true);
        }
    }

    constructor() {
        if (WindowHelper.isElementThere('.is-main-text')) this.attachEvent();
    }
}
